export default {
  init() {

    $(window).on('load', function() {
      $('#phone_provided').detach().insertAfter('#billing_phone').show()

      $('#billing_vat_number_field').hide()
      $('#billing_company_field').hide()
      if($('#billing_vat_checkbox').is(':checked')) {
        $('#billing_vat_number_field').show()
        $('#billing_company_field').show()
      } else {
        $('#billing_vat_number_field').hide()
        $('#billing_company_field').hide()
      }
      $('#billing_vat_checkbox').change(function () {
        if($(this).is(':checked')) {
          $('#billing_vat_number_field').show()
          $('#billing_company_field').show()
        } else {
          $('#billing_vat_number_field').hide()
          $('#billing_company_field').hide()
        }
      })

      // AJAX upload logo fees
      $('#logo_upload').change(function (e) {
        e.preventDefault()
        $('body').trigger('update_checkout')
      })

      setTimeout(() => {
        let uploadLogoCheckbox = $('#uploadLogoCheckbox')
        let logoUploadCheckbox = $('#logo_upload')
        if(uploadLogoCheckbox.is(':checked')){
          uploadLogoCheckbox.prop('checked', false)
        }
        if(logoUploadCheckbox.is(':checked')){
          logoUploadCheckbox.prop('checked', false)
        }
        $('#logo_form').hide()

        let uploadLogoContainer = $('#alg_checkout_files_upload_form_1')
        let uploadLogoProggressBar = $('#alg-wc-checkout-files-upload-progress-wrapper-1')
        uploadLogoContainer.detach().insertBefore('#logo-upload-here').hide()
        uploadLogoProggressBar.detach().insertBefore('#logo-upload-here').hide()
        $('#uploadLogoCheckbox').change(function() {
          $('#logo_upload').trigger('click')
          if($(this).is(':checked')){
            uploadLogoContainer.slideDown()
            uploadLogoProggressBar.slideDown()
            $('#logo_form').slideDown()
          } else {
            $('#alg_checkout_files_upload_form_1').slideUp()
            uploadLogoContainer.slideUp()
              uploadLogoProggressBar.slideUp()
            $('#logo_form').slideUp()
          }
        })
      }, 500);
      setTimeout(() => {
        $('body').trigger('update_checkout')
      }, 600);


    })

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/checkout.js